import '../scss/main.scss'

gsap.registerPlugin(ScrollTrigger)

import { Background } from './commons/background.js'
import { Portals } from './commons/portals.js'

import { Accordion } from './commons/accordion.js'
import { UserFilter } from './commons/userfilter.js'
import Slider from './commons/slider.js'
import Section5 from './commons/section5.js'
import Section9 from './commons/section9.js'
import Inview from './commons/inview.js'
import Modal from './commons/modal.js'
import Menu from './commons/menu.js'
import Search from './commons/search.js'
import Ods from './commons/ods.js'
import Pointer from './commons/pointer.js'
import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'

import { initSmoothScroll } from './commons/scroll.js'

// Text Split Animations
import SplitTextAnimation from './commons/splitText.js'


const App = new function () {
	// const body = document.body;

	this.init = () => {
		
		// Initial setup
		setWin()
		setVh()
		setVw()
		
		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)

		// --- Scroll / GSAP Setup ---
		if (!isTouchDevice) {
			initSmoothScroll() 
		}
		
		// Jsons
		Background.init();
		if (!isTouchDevice) {
			Portals.init();
		}
		
		// Modal
		Modal.init()

		// Menu
		Menu.init()

		// Search
		Search.init()

		// ODS labels
		Ods.init()

		// Home JS
		if(document.querySelector('#home-sec-1')) {
			const scroller = document.querySelector('#sn-page') || document.body
			document.querySelectorAll(".sn-timeline__item").forEach((item) => {
				ScrollTrigger.create({
					trigger: item,
					scroller,
					start: "top center+=100",
					end: "bottom center",
					toggleClass: { targets: item, className: "active" },
					once: false
				});
			});

			gsap.to(".sn-timeline__progress-fill", {
				height: "100%",
				ease: "none",
				scrollTrigger: {
					scroller,
				trigger: ".sn-timeline",
				start: "top center+=100",
				end: "bottom center",
				scrub: true
				}
			});
		}
		// Section 2
		if (document.querySelector('.sn-section--2')) {
			SplitTextAnimation.init()
		}
		// Accordion //-- Must Be Before Inview Init --//
		if (document.querySelector('.sn-section--3')) {
			Accordion.init();
		}
		// Section 5
		if (document.querySelector('.sn-section--5')) {
			Section5.init();
		}
		// Section 9 - Slider
		if (document.querySelector('.sn-section--9')) {
			Pointer.init();
			Section9.init();
			Slider.init();
		}

		// Section 9 – Slider (carga dinámica de Keen)
		// if (document.querySelector('.sn-section--9')) {
		// const loadScript = (src) => {
		// 	return new Promise((resolve, reject) => {
		// 	const s = document.createElement('script');
		// 	s.src = src;
		// 	s.onload = resolve;
		// 	s.onerror = reject;
		// 	document.head.appendChild(s);
		// 	});
		// };

		// const loadStyle = (href) => {
		// 	const link = document.createElement('link');
		// 	link.rel = 'stylesheet';
		// 	link.href = href;
		// 	document.head.appendChild(link);
		// };

		// // Cargar CSS
		// loadStyle('https://cdn.jsdelivr.net/npm/keen-slider@latest/keen-slider.min.css');

		// // Cargar JS y luego ejecutar los init
		// loadScript('https://cdn.jsdelivr.net/npm/keen-slider@latest/keen-slider.min.js').then(() => {
		// 	// Ahora Keen ya está disponible
		// 	if (typeof Slider !== 'undefined') Slider.init();
		// 	if (typeof Pointer !== 'undefined') Pointer.init();
		// 	if (typeof Section9 !== 'undefined') Section9.init();
		// }).catch(err => {
		// 	console.error('No se pudo cargar Keen Slider:', err);
		// });
		// }



		// User Filter
		if (document.querySelector('.sn-section--13')) {
			UserFilter.init();
		}

		// Inview
		Inview.init()
	}


	this.onResize = () => {
		setWin()
		setVh()
		setVw()

		if (document.querySelector('.sn-section--2')) {
			SplitTextAnimation.init()
		}
	}

}

window.addEventListener('load', App.init)